import { MetaProps, PageType } from '@benzinga/seo';
import { buildScreenerMetaProps } from '../app/(site)/screener/screenerMeta';
import { GROWTH_SCREENER_CONFIG } from './growth-config';
import { MOMENTUM_SCREENER_CONFIG } from './momentum-config';
import { QUALITY_SCREENER_CONFIG } from './quality-config';
import type { ScreenerPageConfig } from './shared-screener-config';
import { VALUE_SCREENER_CONFIG } from './value-config';

export const screenerConfigMap: Record<string, { config: ScreenerPageConfig; meta: MetaProps }> = {
  'best-momentum-stocks': {
    config: MOMENTUM_SCREENER_CONFIG,
    meta: buildScreenerMetaProps(
      {
        description:
          'Discover top-performing stocks with strong momentum indicators. Our momentum screener identifies stocks with the strongest price momentum, helping you find potential winners in the market.',
        pageType: PageType.Tool,
        title: 'Best Momentum Stocks - Top Performing Stocks with Strong Momentum | Benzinga',
      },
      '/screener/best-momentum-stocks',
    ),
  },
  'best-value-stocks': {
    config: VALUE_SCREENER_CONFIG,
    meta: buildScreenerMetaProps(
      {
        description:
          'Find undervalued stocks with strong fundamentals. Our value screener identifies undervalued stocks with strong fundamentals, helping you find bargains in the market.',
        pageType: PageType.Tool,
        title: 'Best Value Stocks - Find Undervalued Stocks with Strong Fundamentals | Benzinga',
      },
      '/screener/best-value-stocks',
    ),
  },
  'best-growth-stocks': {
    config: GROWTH_SCREENER_CONFIG,
    meta: buildScreenerMetaProps(
      {
        description:
          'Discover high-growth stocks with exceptional expansion potential. Our growth screener identifies stocks with strong revenue and earnings growth, expanding markets, and scalable business models.',
        pageType: PageType.Tool,
        title: 'Best Growth Stocks - High-Growth Stocks with Exceptional Expansion Potential | Benzinga',
      },
      '/screener/best-growth-stocks',
    ),
  },
  'best-quality-stocks': {
    config: QUALITY_SCREENER_CONFIG,
    meta: buildScreenerMetaProps(
      {
        description:
          'Discover top-performing stocks with exceptional quality metrics. Our quality screener identifies stocks with strong balance sheets, consistent earnings, and excellent management quality.',
        pageType: PageType.Tool,
        title: 'Best Quality Stocks - Stocks with Exceptional Quality Metrics | Benzinga',
      },
      '/screener/best-quality-stocks',
    ),
  },
};
